import { reactive } from 'vue'
import { useBreakpoint, useBreakpointTailwindCSS, type BreakpointObject } from 'vue-composable'
import { useTailwindConfig } from '../useTailwindConfig/index'

export function useMediaQuery() {
  const screens = useTailwindConfig().theme?.screens as BreakpointObject
  if (screens && !('xs' in screens)) {
    screens.xs = '1px'
    return reactive(useBreakpoint(screens))
  } else {
    return reactive(useBreakpointTailwindCSS(useTailwindConfig()))
  }
}
